import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";
import store from "@/store";

import { MobileRegisterTheme, DesktopRegisterTheme } from ".";

import { tabList } from "@/common/settings/register";


export default /*@__PURE__*/_defineComponent({
  __name: 'register',
  props: {
    tabActive: {}
  },
  setup(__props: any) {

const { t } = useI18n();
const route = useRoute();



const accountId = computed(() => route.params.id as string);

const menuList = computed(() =>
  tabList.reduce((acc, item) => {
    const modules = store.getters.modules;

    if (modules.find((mod) => mod.code === `${item.key.toUpperCase()}_NOT`)) {
      return acc;
    } else {
      acc.push({
        ...item,
        label: t(item.label),
        url: `/${accountId.value}${item.url}`,
      });
    }

    return acc;
  }, []),
);

return (_ctx: any,_cache: any) => {
  return (!_ctx.$store.getters.mobile)
    ? (_openBlock(), _createBlock(_unref(DesktopRegisterTheme), {
        key: 0,
        "menu-list": menuList.value,
        "tab-active": __props.tabActive
      }, {
        title: _withCtx(() => [
          _renderSlot(_ctx.$slots, "title")
        ]),
        content: _withCtx(() => [
          _renderSlot(_ctx.$slots, "content")
        ]),
        _: 3
      }, 8, ["menu-list", "tab-active"]))
    : (_openBlock(), _createBlock(_unref(MobileRegisterTheme), {
        key: 1,
        "menu-list": menuList.value,
        "account-id": accountId.value,
        "tab-active": __props.tabActive
      }, {
        title: _withCtx(() => [
          _renderSlot(_ctx.$slots, "title")
        ]),
        content: _withCtx(() => [
          _renderSlot(_ctx.$slots, "content")
        ]),
        _: 3
      }, 8, ["menu-list", "account-id", "tab-active"]))
}
}

})